export const createErrorMessage = (error: unknown): string => {
    return error instanceof Error ? error.message : String(error);
};

export const createError = (prefix: string, error: unknown): Error => {
    const argumentMessage = createErrorMessage(error);
    const fullMessage = `${prefix}: ${argumentMessage}`;
    return new Error(fullMessage);
};

export const createErrorFactory = (prefix: string): ((error: unknown) => Error) => {
    return (error: unknown) => createError(prefix, error);
};
